// Marketing tracking: Meta Pixel (after cookie consent) + first-touch UTM / promo attribution
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const CONSENT_KEY = 'biosounds_cookie_consent';
const ATTR_KEY = 'biosounds_attribution';
const ATTR_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'fbclid', 'gclid', 'ref'];
const PROMO_PARAMS = ['promo', 'promo_code', 'codigo', 'coupon'];

const hasConsent = () => {
  try { return JSON.parse(localStorage.getItem(CONSENT_KEY))?.accepted === true; } catch { return false; }
};

let pixelLoaded = false;
export const initMetaPixel = () => {
  if (pixelLoaded || !PIXEL_ID || !hasConsent() || typeof window === 'undefined') return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', PIXEL_ID);
  pixelLoaded = true;
  window.fbq('track', 'PageView');
};

export const trackPageView = () => {
  if (pixelLoaded && window.fbq) window.fbq('track', 'PageView');
};

// eventID lets Meta deduplicate browser + Conversions API events
export const trackEvent = (name, params = {}, eventId) => {
  if (!pixelLoaded || !window.fbq) return;
  window.fbq('track', name, params, eventId ? { eventID: eventId } : undefined);
};

export const captureAttribution = () => {
  try {
    const qs = new URLSearchParams(window.location.search);
    const found = {};
    ATTR_PARAMS.forEach((k) => { if (qs.get(k)) found[k] = qs.get(k); });
    const promo = PROMO_PARAMS.map((k) => qs.get(k)).find(Boolean);
    if (promo) found.promo_code = promo;
    if (!Object.keys(found).length) {
      if (!localStorage.getItem(ATTR_KEY) && document.referrer && !document.referrer.includes(window.location.host)) {
        localStorage.setItem(ATTR_KEY, JSON.stringify({
          utm_source: new URL(document.referrer).hostname, referrer: document.referrer,
          landing_page: window.location.pathname, captured_at: new Date().toISOString(),
        }));
      }
      return;
    }
    // Last click with campaign params wins until the user registers
    localStorage.setItem(ATTR_KEY, JSON.stringify({
      ...found, referrer: document.referrer || undefined,
      landing_page: window.location.pathname, captured_at: new Date().toISOString(),
    }));
  } catch { /* storage unavailable */ }
};

export const getAttribution = () => {
  try { return JSON.parse(localStorage.getItem(ATTR_KEY)) || null; } catch { return null; }
};

export const clearAttribution = () => localStorage.removeItem(ATTR_KEY);
